import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ServiceBase } from './service.base';

export interface JDOrganization {
  id: string;
  name: string;
}

export interface JohnDeereStatus {
  connected: boolean;
  organization?: JDOrganization;
  tokenExpiry?: string;
  connectedAt?: string;
  revokedAtOC?: boolean;
  // True when a connection exists but the user hasn't picked an organization on
  // John Deere's Operations Center "select-organizations" page yet.
  pending?: boolean;
}

export interface JohnDeereFinalizeResult {
  connected: boolean;
  organization?: JDOrganization;
}

@Injectable({
  providedIn: 'root',
})
export class JohnDeereService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  getStatus(): Observable<JohnDeereStatus> {
    return this.http
      .get<JohnDeereStatus>(
        `${this.UrlServiceV1}john-deere-status`,
        this.obterAuthHeader(),
      )
      .pipe(catchError(this.serviceError));
  }

  getAuthorizationUrl(): Observable<{ authorizationUrl: string }> {
    return this.http
      .get<{ authorizationUrl: string }>(
        `${this.UrlServiceV1}john-deere-auth`,
        this.obterAuthHeader(),
      )
      .pipe(catchError(this.serviceError));
  }

  finalizeConnection(): Observable<JohnDeereFinalizeResult> {
    return this.http
      .post<JohnDeereFinalizeResult>(
        `${this.UrlServiceV1}john-deere-finalize-connection`,
        {},
        this.obterAuthHeader(),
      )
      .pipe(catchError(this.serviceError));
  }

  disconnect(): Observable<{ message: string }> {
    return this.http
      .delete<{ message: string }>(
        `${this.UrlServiceV1}john-deere-disconnect`,
        this.obterAuthHeader(),
      )
      .pipe(catchError(this.serviceError));
  }

  sendTaskdata(taskdata: string): Observable<{ message: string; fileId: string }> {
    return this.http
      .post<{ message: string; fileId: string }>(
        `${this.UrlServiceV1}john-deere-send-taskdata`,
        { taskdata },
        this.obterAuthHeader(),
      )
      .pipe(catchError(this.serviceError));
  }
}
